// Complete country name translations for all 5 supported languages
// Based on ISO 3166-1 official country names

export type SupportedLanguage = 'en' | 'pt' | 'es' | 'fr' | 'ja';

export const countryNames: Record<string, Record<SupportedLanguage, string>> = {
  // A
  "Albania": { en: "Albania", pt: "Albânia", es: "Albania", fr: "Albanie", ja: "アルバニア" },
  "Algeria": { en: "Algeria", pt: "Argélia", es: "Argelia", fr: "Algérie", ja: "アルジェリア" },
  "Andorra": { en: "Andorra", pt: "Andorra", es: "Andorra", fr: "Andorre", ja: "アンドラ" },
  "Argentina": { en: "Argentina", pt: "Argentina", es: "Argentina", fr: "Argentine", ja: "アルゼンチン" },
  "Armenia": { en: "Armenia", pt: "Arménia", es: "Armenia", fr: "Arménie", ja: "アルメニア" },
  "Australia": { en: "Australia", pt: "Austrália", es: "Australia", fr: "Australie", ja: "オーストラリア" },
  "Austria": { en: "Austria", pt: "Áustria", es: "Austria", fr: "Autriche", ja: "オーストリア" },
  "Azerbaijan": { en: "Azerbaijan", pt: "Azerbaijão", es: "Azerbaiyán", fr: "Azerbaïdjan", ja: "アゼルバイジャン" },
  
  // B
  "Bahamas": { en: "Bahamas", pt: "Bahamas", es: "Bahamas", fr: "Bahamas", ja: "バハマ" },
  "Bahrain": { en: "Bahrain", pt: "Bahrein", es: "Baréin", fr: "Bahreïn", ja: "バーレーン" },
  "Bangladesh": { en: "Bangladesh", pt: "Bangladesh", es: "Bangladés", fr: "Bangladesh", ja: "バングラデシュ" },
  "Belarus": { en: "Belarus", pt: "Bielorrússia", es: "Bielorrusia", fr: "Biélorussie", ja: "ベラルーシ" },
  "Belgium": { en: "Belgium", pt: "Bélgica", es: "Bélgica", fr: "Belgique", ja: "ベルギー" },
  "Belize": { en: "Belize", pt: "Belize", es: "Belice", fr: "Belize", ja: "ベリーズ" },
  "Benin": { en: "Benin", pt: "Benim", es: "Benín", fr: "Bénin", ja: "ベナン" },
  "Bermuda": { en: "Bermuda", pt: "Bermudas", es: "Bermudas", fr: "Bermudes", ja: "バミューダ" },
  "Bolivia": { en: "Bolivia", pt: "Bolívia", es: "Bolivia", fr: "Bolivie", ja: "ボリビア" },
  "Bosnia-Herzegovina": { en: "Bosnia-Herzegovina", pt: "Bósnia-Herzegovina", es: "Bosnia-Herzegovina", fr: "Bosnie-Herzégovine", ja: "ボスニア・ヘルツェゴビナ" },
  "Botswana": { en: "Botswana", pt: "Botsuana", es: "Botsuana", fr: "Botswana", ja: "ボツワナ" },
  "Brazil": { en: "Brazil", pt: "Brasil", es: "Brasil", fr: "Brésil", ja: "ブラジル" },
  "Bulgaria": { en: "Bulgaria", pt: "Bulgária", es: "Bulgaria", fr: "Bulgarie", ja: "ブルガリア" },
  "Burkina Faso": { en: "Burkina Faso", pt: "Burkina Faso", es: "Burkina Faso", fr: "Burkina Faso", ja: "ブルキナファソ" },
  
  // C
  "Cambodia": { en: "Cambodia", pt: "Camboja", es: "Camboya", fr: "Cambodge", ja: "カンボジア" },
  "Cameroon": { en: "Cameroon", pt: "Camarões", es: "Camerún", fr: "Cameroun", ja: "カメルーン" },
  "Canada": { en: "Canada", pt: "Canadá", es: "Canadá", fr: "Canada", ja: "カナダ" },
  "Catalonia": { en: "Catalonia", pt: "Catalunha", es: "Cataluña", fr: "Catalogne", ja: "カタルーニャ" },
  "Chad": { en: "Chad", pt: "Chade", es: "Chad", fr: "Tchad", ja: "チャド" },
  "Chile": { en: "Chile", pt: "Chile", es: "Chile", fr: "Chili", ja: "チリ" },
  "China": { en: "China", pt: "China", es: "China", fr: "Chine", ja: "中国" },
  "Colombia": { en: "Colombia", pt: "Colômbia", es: "Colombia", fr: "Colombie", ja: "コロンビア" },
  "Comoros": { en: "Comoros", pt: "Comores", es: "Comoras", fr: "Comores", ja: "コモロ" },
  "Congo": { en: "Congo", pt: "Congo", es: "Congo", fr: "Congo", ja: "コンゴ" },
  "Costa Rica": { en: "Costa Rica", pt: "Costa Rica", es: "Costa Rica", fr: "Costa Rica", ja: "コスタリカ" },
  "Cote d'Ivoire": { en: "Côte d'Ivoire", pt: "Costa do Marfim", es: "Costa de Marfil", fr: "Côte d'Ivoire", ja: "コートジボワール" },
  "Croatia": { en: "Croatia", pt: "Croácia", es: "Croacia", fr: "Croatie", ja: "クロアチア" },
  "Cyprus": { en: "Cyprus", pt: "Chipre", es: "Chipre", fr: "Chypre", ja: "キプロス" },
  "Czech Republic": { en: "Czech Republic", pt: "República Tcheca", es: "República Checa", fr: "République tchèque", ja: "チェコ共和国" },
  
  // D
  "Democratic Republic of Congo": { en: "Democratic Republic of Congo", pt: "República Democrática do Congo", es: "República Democrática del Congo", fr: "République démocratique du Congo", ja: "コンゴ民主共和国" },
  "Denmark": { en: "Denmark", pt: "Dinamarca", es: "Dinamarca", fr: "Danemark", ja: "デンマーク" },
  "Djibouti": { en: "Djibouti", pt: "Djibuti", es: "Yibuti", fr: "Djibouti", ja: "ジブチ" },
  "Dominican Republic": { en: "Dominican Republic", pt: "República Dominicana", es: "República Dominicana", fr: "République dominicaine", ja: "ドミニカ共和国" },
  "Dutch Caribbean": { en: "Dutch Caribbean", pt: "Caribe Holandês", es: "Caribe Neerlandés", fr: "Caraïbes néerlandaises", ja: "オランダ領カリブ" },
  
  // E
  "Ecuador": { en: "Ecuador", pt: "Equador", es: "Ecuador", fr: "Équateur", ja: "エクアドル" },
  "Egypt": { en: "Egypt", pt: "Egito", es: "Egipto", fr: "Égypte", ja: "エジプト" },
  "El Salvador": { en: "El Salvador", pt: "El Salvador", es: "El Salvador", fr: "Salvador", ja: "エルサルバドル" },
  "Estonia": { en: "Estonia", pt: "Estónia", es: "Estonia", fr: "Estonie", ja: "エストニア" },
  
  // F
  "Fiji": { en: "Fiji", pt: "Fiji", es: "Fiyi", fr: "Fidji", ja: "フィジー" },
  "Finland": { en: "Finland", pt: "Finlândia", es: "Finlandia", fr: "Finlande", ja: "フィンランド" },
  "France": { en: "France", pt: "França", es: "Francia", fr: "France", ja: "フランス" },
  
  // G
  "Gabon": { en: "Gabon", pt: "Gabão", es: "Gabón", fr: "Gabon", ja: "ガボン" },
  "Gambia": { en: "Gambia", pt: "Gâmbia", es: "Gambia", fr: "Gambie", ja: "ガンビア" },
  "Georgia": { en: "Georgia", pt: "Geórgia", es: "Georgia", fr: "Géorgie", ja: "ジョージア" },
  "Germany": { en: "Germany", pt: "Alemanha", es: "Alemania", fr: "Allemagne", ja: "ドイツ" },
  "Ghana": { en: "Ghana", pt: "Gana", es: "Ghana", fr: "Ghana", ja: "ガーナ" },
  "Greece": { en: "Greece", pt: "Grécia", es: "Grecia", fr: "Grèce", ja: "ギリシャ" },
  "Guatemala": { en: "Guatemala", pt: "Guatemala", es: "Guatemala", fr: "Guatemala", ja: "グアテマラ" },
  "Guinea": { en: "Guinea", pt: "Guiné", es: "Guinea", fr: "Guinée", ja: "ギニア" },
  
  // H
  "Haiti": { en: "Haiti", pt: "Haiti", es: "Haití", fr: "Haïti", ja: "ハイチ" },
  "Honduras": { en: "Honduras", pt: "Honduras", es: "Honduras", fr: "Honduras", ja: "ホンジュラス" },
  "Hong Kong": { en: "Hong Kong", pt: "Hong Kong", es: "Hong Kong", fr: "Hong Kong", ja: "香港" },
  "Hungary": { en: "Hungary", pt: "Hungria", es: "Hungría", fr: "Hongrie", ja: "ハンガリー" },
  
  // I
  "Iceland": { en: "Iceland", pt: "Islândia", es: "Islandia", fr: "Islande", ja: "アイスランド" },
  "India": { en: "India", pt: "Índia", es: "India", fr: "Inde", ja: "インド" },
  "Indonesia": { en: "Indonesia", pt: "Indonésia", es: "Indonesia", fr: "Indonésie", ja: "インドネシア" },
  "Iran": { en: "Iran", pt: "Irã", es: "Irán", fr: "Iran", ja: "イラン" },
  "Ireland": { en: "Ireland", pt: "Irlanda", es: "Irlanda", fr: "Irlande", ja: "アイルランド" },
  "Israel": { en: "Israel", pt: "Israel", es: "Israel", fr: "Israël", ja: "イスラエル" },
  "Italy": { en: "Italy", pt: "Itália", es: "Italia", fr: "Italie", ja: "イタリア" },
  
  // J
  "Jamaica": { en: "Jamaica", pt: "Jamaica", es: "Jamaica", fr: "Jamaïque", ja: "ジャマイカ" },
  "Japan": { en: "Japan", pt: "Japão", es: "Japón", fr: "Japon", ja: "日本" },
  "Jordan": { en: "Jordan", pt: "Jordânia", es: "Jordania", fr: "Jordanie", ja: "ヨルダン" },
  
  // K
  "Kazakhstan": { en: "Kazakhstan", pt: "Cazaquistão", es: "Kazajistán", fr: "Kazakhstan", ja: "カザフスタン" },
  "Kenya": { en: "Kenya", pt: "Quênia", es: "Kenia", fr: "Kenya", ja: "ケニア" },
  "Korea": { en: "Korea", pt: "Coreia", es: "Corea", fr: "Corée", ja: "韓国" },
  "Kosovo": { en: "Kosovo", pt: "Kosovo", es: "Kosovo", fr: "Kosovo", ja: "コソボ" },
  
  // L
  "Latvia": { en: "Latvia", pt: "Letónia", es: "Letonia", fr: "Lettonie", ja: "ラトビア" },
  "Lebanon": { en: "Lebanon", pt: "Líbano", es: "Líbano", fr: "Liban", ja: "レバノン" },
  "Lesotho": { en: "Lesotho", pt: "Lesoto", es: "Lesoto", fr: "Lesotho", ja: "レソト" },
  "Liberia": { en: "Liberia", pt: "Libéria", es: "Liberia", fr: "Libéria", ja: "リベリア" },
  "Lithuania": { en: "Lithuania", pt: "Lituânia", es: "Lituania", fr: "Lituanie", ja: "リトアニア" },
  "Luxembourg": { en: "Luxembourg", pt: "Luxemburgo", es: "Luxemburgo", fr: "Luxembourg", ja: "ルクセンブルク" },
  
  // M
  "Macao": { en: "Macao", pt: "Macau", es: "Macao", fr: "Macao", ja: "マカオ" },
  "Macedonia": { en: "Macedonia", pt: "Macedónia", es: "Macedonia", fr: "Macédoine", ja: "マケドニア" },
  "Madagascar": { en: "Madagascar", pt: "Madagáscar", es: "Madagascar", fr: "Madagascar", ja: "マダガスカル" },
  "Malawi": { en: "Malawi", pt: "Malawi", es: "Malaui", fr: "Malawi", ja: "マラウイ" },
  "Malaysia": { en: "Malaysia", pt: "Malásia", es: "Malasia", fr: "Malaisie", ja: "マレーシア" },
  "Maldives": { en: "Maldives", pt: "Maldivas", es: "Maldivas", fr: "Maldives", ja: "モルディブ" },
  "Mali": { en: "Mali", pt: "Mali", es: "Malí", fr: "Mali", ja: "マリ" },
  "Malta": { en: "Malta", pt: "Malta", es: "Malta", fr: "Malte", ja: "マルタ" },
  "Mauritius": { en: "Mauritius", pt: "Maurício", es: "Mauricio", fr: "Maurice", ja: "モーリシャス" },
  "Mexico": { en: "Mexico", pt: "México", es: "México", fr: "Mexique", ja: "メキシコ" },
  "Moldova": { en: "Moldova", pt: "Moldávia", es: "Moldavia", fr: "Moldavie", ja: "モルドバ" },
  "Monaco": { en: "Monaco", pt: "Mónaco", es: "Mónaco", fr: "Monaco", ja: "モナコ" },
  "Mongolia": { en: "Mongolia", pt: "Mongólia", es: "Mongolia", fr: "Mongolie", ja: "モンゴル" },
  "Morocco": { en: "Morocco", pt: "Marrocos", es: "Marruecos", fr: "Maroc", ja: "モロッコ" },
  "Mozambique": { en: "Mozambique", pt: "Moçambique", es: "Mozambique", fr: "Mozambique", ja: "モザンビーク" },
  "Myanmar": { en: "Myanmar", pt: "Mianmar", es: "Myanmar", fr: "Birmanie", ja: "ミャンマー" },
  
  // N
  "Namibia": { en: "Namibia", pt: "Namíbia", es: "Namibia", fr: "Namibie", ja: "ナミビア" },
  "Nepal": { en: "Nepal", pt: "Nepal", es: "Nepal", fr: "Népal", ja: "ネパール" },
  "Netherlands": { en: "Netherlands", pt: "Países Baixos", es: "Países Bajos", fr: "Pays-Bas", ja: "オランダ" },
  "New Zealand": { en: "New Zealand", pt: "Nova Zelândia", es: "Nueva Zelanda", fr: "Nouvelle-Zélande", ja: "ニュージーランド" },
  "Nicaragua": { en: "Nicaragua", pt: "Nicarágua", es: "Nicaragua", fr: "Nicaragua", ja: "ニカラグア" },
  "Niger": { en: "Niger", pt: "Níger", es: "Níger", fr: "Niger", ja: "ニジェール" },
  "Nigeria": { en: "Nigeria", pt: "Nigéria", es: "Nigeria", fr: "Nigéria", ja: "ナイジェリア" },
  "Norway": { en: "Norway", pt: "Noruega", es: "Noruega", fr: "Norvège", ja: "ノルウェー" },
  
  // P
  "Pacific": { en: "Pacific", pt: "Pacífico", es: "Pacífico", fr: "Pacifique", ja: "太平洋" },
  "Pakistan": { en: "Pakistan", pt: "Paquistão", es: "Pakistán", fr: "Pakistan", ja: "パキスタン" },
  "Panama": { en: "Panama", pt: "Panamá", es: "Panamá", fr: "Panama", ja: "パナマ" },
  "Papua New Guinea": { en: "Papua New Guinea", pt: "Papua-Nova Guiné", es: "Papúa Nueva Guinea", fr: "Papouasie-Nouvelle-Guinée", ja: "パプアニューギニア" },
  "Paraguay": { en: "Paraguay", pt: "Paraguai", es: "Paraguay", fr: "Paraguay", ja: "パラグアイ" },
  "Peru": { en: "Peru", pt: "Peru", es: "Perú", fr: "Pérou", ja: "ペルー" },
  "Philippines": { en: "Philippines", pt: "Filipinas", es: "Filipinas", fr: "Philippines", ja: "フィリピン" },
  "Poland": { en: "Poland", pt: "Polónia", es: "Polonia", fr: "Pologne", ja: "ポーランド" },
  "Portugal": { en: "Portugal", pt: "Portugal", es: "Portugal", fr: "Portugal", ja: "ポルトガル" },
  "Puerto Rico": { en: "Puerto Rico", pt: "Porto Rico", es: "Puerto Rico", fr: "Porto Rico", ja: "プエルトリコ" },
  
  // R
  "Romania": { en: "Romania", pt: "Roménia", es: "Rumania", fr: "Roumanie", ja: "ルーマニア" },
  "Russia": { en: "Russia", pt: "Rússia", es: "Rusia", fr: "Russie", ja: "ロシア" },
  "Rwanda": { en: "Rwanda", pt: "Ruanda", es: "Ruanda", fr: "Rwanda", ja: "ルワンダ" },
  
  // S
  "Saudi Arabia": { en: "Saudi Arabia", pt: "Arábia Saudita", es: "Arabia Saudita", fr: "Arabie saoudite", ja: "サウジアラビア" },
  "Scotland": { en: "Scotland", pt: "Escócia", es: "Escocia", fr: "Écosse", ja: "スコットランド" },
  "Senegal": { en: "Senegal", pt: "Senegal", es: "Senegal", fr: "Sénégal", ja: "セネガル" },
  "Serbia": { en: "Serbia", pt: "Sérvia", es: "Serbia", fr: "Serbie", ja: "セルビア" },
  "Seychelles": { en: "Seychelles", pt: "Seychelles", es: "Seychelles", fr: "Seychelles", ja: "セーシェル" },
  "Sierra Leone": { en: "Sierra Leone", pt: "Serra Leoa", es: "Sierra Leona", fr: "Sierra Leone", ja: "シエラレオネ" },
  "Singapore": { en: "Singapore", pt: "Singapura", es: "Singapur", fr: "Singapour", ja: "シンガポール" },
  "Slovakia": { en: "Slovakia", pt: "Eslováquia", es: "Eslovaquia", fr: "Slovaquie", ja: "スロバキア" },
  "Slovenia": { en: "Slovenia", pt: "Eslovénia", es: "Eslovenia", fr: "Slovénie", ja: "スロベニア" },
  "South Africa": { en: "South Africa", pt: "África do Sul", es: "Sudáfrica", fr: "Afrique du Sud", ja: "南アフリカ" },
  "South Sudan": { en: "South Sudan", pt: "Sudão do Sul", es: "Sudán del Sur", fr: "Soudan du Sud", ja: "南スーダン" },
  "Spain": { en: "Spain", pt: "Espanha", es: "España", fr: "Espagne", ja: "スペイン" },
  "Sri Lanka": { en: "Sri Lanka", pt: "Sri Lanka", es: "Sri Lanka", fr: "Sri Lanka", ja: "スリランカ" },
  "Suriname": { en: "Suriname", pt: "Suriname", es: "Surinam", fr: "Suriname", ja: "スリナム" },
  "Swaziland": { en: "Eswatini", pt: "Essuatíni", es: "Esuatini", fr: "Eswatini", ja: "エスワティニ" },
  "Sweden": { en: "Sweden", pt: "Suécia", es: "Suecia", fr: "Suède", ja: "スウェーデン" },
  "Switzerland": { en: "Switzerland", pt: "Suíça", es: "Suiza", fr: "Suisse", ja: "スイス" },
  "Syria": { en: "Syria", pt: "Síria", es: "Siria", fr: "Syrie", ja: "シリア" },
  
  // T
  "Taiwan": { en: "Taiwan", pt: "Taiwan", es: "Taiwán", fr: "Taïwan", ja: "台湾" },
  "Tanzania": { en: "Tanzania", pt: "Tanzânia", es: "Tanzania", fr: "Tanzanie", ja: "タンザニア" },
  "Thailand": { en: "Thailand", pt: "Tailândia", es: "Tailandia", fr: "Thaïlande", ja: "タイ" },
  "Timor Leste": { en: "Timor-Leste", pt: "Timor-Leste", es: "Timor Oriental", fr: "Timor oriental", ja: "東ティモール" },
  "Togo": { en: "Togo", pt: "Togo", es: "Togo", fr: "Togo", ja: "トーゴ" },
  "Tunisia": { en: "Tunisia", pt: "Tunísia", es: "Túnez", fr: "Tunisie", ja: "チュニジア" },
  "Turkey": { en: "Turkey", pt: "Turquia", es: "Turquía", fr: "Turquie", ja: "トルコ" },
  
  // U
  "UAE": { en: "United Arab Emirates", pt: "Emirados Árabes Unidos", es: "Emiratos Árabes Unidos", fr: "Émirats arabes unis", ja: "アラブ首長国連邦" },
  "Uganda": { en: "Uganda", pt: "Uganda", es: "Uganda", fr: "Ouganda", ja: "ウガンダ" },
  "Ukraine": { en: "Ukraine", pt: "Ucrânia", es: "Ucrania", fr: "Ukraine", ja: "ウクライナ" },
  "United Kingdom": { en: "United Kingdom", pt: "Reino Unido", es: "Reino Unido", fr: "Royaume-Uni", ja: "イギリス" },
  "United States of America": { en: "United States", pt: "Estados Unidos", es: "Estados Unidos", fr: "États-Unis", ja: "アメリカ合衆国" },
  "Uruguay": { en: "Uruguay", pt: "Uruguai", es: "Uruguay", fr: "Uruguay", ja: "ウルグアイ" },
  "Uzbekistan": { en: "Uzbekistan", pt: "Uzbequistão", es: "Uzbekistán", fr: "Ouzbékistan", ja: "ウズベキスタン" },
  
  // V
  "Vanuatu": { en: "Vanuatu", pt: "Vanuatu", es: "Vanuatu", fr: "Vanuatu", ja: "バヌアツ" },
  "Venezuela": { en: "Venezuela", pt: "Venezuela", es: "Venezuela", fr: "Venezuela", ja: "ベネズエラ" },
  "Vietnam": { en: "Vietnam", pt: "Vietnã", es: "Vietnam", fr: "Viêt Nam", ja: "ベトナム" },
  
  // W
  "West Indies": { en: "West Indies", pt: "Índias Ocidentais", es: "Indias Occidentales", fr: "Antilles", ja: "西インド諸島" },
  
  // Y
  "Yemen": { en: "Yemen", pt: "Iémen", es: "Yemen", fr: "Yémen", ja: "イエメン" },
  
  // Z
  "Zambia": { en: "Zambia", pt: "Zâmbia", es: "Zambia", fr: "Zambie", ja: "ザンビア" },
  "Zimbabwe": { en: "Zimbabwe", pt: "Zimbábue", es: "Zimbabue", fr: "Zimbabwe", ja: "ジンバブエ" },
};

/**
 * Get the localized country name for a given English country name
 * @param englishName - The English name of the country (key in countryFlags)
 * @param language - The target language code
 * @returns The localized country name, or the English name if not found
 */
export function getLocalizedCountryName(englishName: string, language: string): string {
  const lang = language as SupportedLanguage;
  return countryNames[englishName]?.[lang] || countryNames[englishName]?.en || englishName;
}
